import { useState } from "react";
import { Box, useTheme } from "@mui/material";
import { useInterval } from "@dvrt/react-tools";

const DebugInfoPanel = ({ track }: { track: MediaStreamTrack }) => {
    const [settings, updateSettings] = useState(track.getSettings());
    const theme = useTheme();

    useInterval(() => {
        updateSettings(track.getSettings());
    }, 1000);

    return (
        <Box
            sx={{
                position: "absolute",
                top: 5,
                left: 5,
                backgroundColor: "rgba(10, 10, 10, 0.6)",
                padding: "3px 7px",
                borderRadius: theme.shape.borderRadius,
                backdropFilter: "blur(4px)",
                color: "white",
            }}
        >
            <table>
                <tbody>
                    <tr>
                        <td>width:</td>
                        <td>{settings.width}</td>
                    </tr>
                    <tr>
                        <td>height:</td>
                        <td>{settings.height}</td>
                    </tr>
                    <tr>
                        <td>fps:</td>
                        <td>{settings.frameRate?.toPrecision(4)}</td>
                    </tr>
                </tbody>
            </table>
        </Box>
    );
};

export default DebugInfoPanel;
